/* Built In Imports */
import { useRouter } from 'next/router';

/* External Imports */
import { Box, Flex, Text } from '@chakra-ui/react';
import { nanoid } from 'nanoid';
import { TiLocationOutline } from 'react-icons/ti';

/* Internal Imports */
/* Components */
import BackIcon from '@lb/components/Icons/BackIcon';
import ShareIcon from '@lb/components/Icons/ShareIcon';

/* Styles */
/* Services */

/**
 * Returns the Top Banner Event .
 *
 * @param {object} pageData - Content from API
 * @param {string} region - Region of page
 * @param {string} language - Lang of page
 * @returns {ReactElement} TopBannerEvent component
 */

const TopBannerEventRitual = ({ pageData, region, language }) => {
  const currentUrl = useRouter();
  const url = currentUrl.asPath;

  return (
    <Box
      maxW="1330px"
      pos="relative"
      margin={{ base: '0 auto 60px', md: '0 auto 80px' }}
      width="100%"
      minH={{ base: '256px', md: '490px' }}
      height="auto"
      // id="BannerContainer"
    >
      <Box
        // bg="gray"
        backgroundImage={{
          base: pageData?.heroImageMobile?.url || pageData?.heroImage?.url,
          md: pageData?.heroImage?.url,
        }}
        backgroundSize="cover"
        backgroundPosition="center"
        h="100%"
        minH={{ base: '206px', md: '490px' }}
        display="flex"
        alignItems="flex-end"
        justifyContent="flex-end"
        position="relative"
        zIndex="2"
        pt="0"
        _before={{
          content: '""',
          position: 'absolute',
          width: { base: '70px', md: '236px' },
          bottom: { base: '-70px', md: '-150px' },
          zIndex: 0,
          left: '0px',
          background:
            'linear-gradient(180deg, rgba(239, 221, 155, 0.7) 0%, rgba(214, 164, 118, 0) 100%)',
          backgroundBlendMode: 'multiply',
          transform: 'matrix(-1, 0, 0, 1, 0, 0)',
          height: { base: '70px', md: '150px' },
        }}
      >
        <Flex
          alignSelf="flex-start"
          // width="100%"
          position="absolute"
          top="30px"
          left="64px"
          right="45px"
          justifyContent="flex-start"
          display={{ base: 'none', md: 'flex' }}
        >
          <BackIcon region={region} language={language} />
          <Box as="span" ml="15px">
            <ShareIcon url={url} background="#A9392D" />
          </Box>
        </Flex>
        <Box
          w={{ base: '100%', md: '80%' }}
          padding={{ base: '17px 16px 10px', md: '38px 59px 20px' }}
          maxW="904px"
          h="auto"
          // left={{ base: '16px', md: '15%' }}
          // py={{ base: '30px', md: '50px' }}
          // right={{ base: '16px', md: '15%' }}
          margin={{ base: '40px 16px 0px', md: '20px auto 0px' }}
          top={{ base: 'auto', md: '0px' }}
          pos="relative"
          display="grid"
          placeItems="inherit"
          // bottom={{ base: '-20px', md: '-50px' }}
          background="linear-gradient(90deg, rgba(86, 8, 0, 0.8) 0%, rgba(86, 8, 0, 0.1) 100%)"
          backgroundBlendMode="multiply"
          _before={{
            content: "''",
            width: '100%',
            height: { base: '15px', md: '40px' },
            position: 'absolute',
            bottom: { base: '-15px', md: '-40px' },
            left: '0',
            background:
              'linear-gradient(90deg, rgba(210, 100, 26, 0.8) 0%, rgba(210, 100, 26, 0) 100%)',
            backgroundBlendMode: 'multiply',
          }}
        >
          <Box
            w="100%"
            height="auto"
            mb={{ base: '8px', md: '14px' }}
            maxW="652px"
            display="flex"
            justifyContent="flex-start"
            flexDir="column"
          >
            {pageData?.title && (
              <Text
                fontSize={{ base: '32px', md: 'h5', lg: 'h2' }}
                as="h1"
                p={0}
                m={0}
                lineHeight={{
                  base: '34px',
                  sm: '34px',
                  md: '60px',
                  lg: '75px',
                  xl: '80px',
                }}
                color="title.light"
                maxW={{ base: '261px', md: '652px', lg: '652px' }}
                fontFamily="FedraSerifDisplay, serif"
              >
                {pageData?.title}
              </Text>
            )}
            <Flex mt="25px">
              <Box px="6px" py="2px" bg="#DF6F3B" mr="10px">
                <Text
                  fontFamily="FedraSansStd-book, sans-serif"
                  fontStyle="normal"
                  fontWeight="500"
                  fontSize={{ base: '9px', md: 'body2' }}
                  lineHeight={{ base: '12.46px', md: '22.14px' }}
                  textAlign="center"
                  letterSpacing="0.06em"
                  textTransform="uppercase"
                  color="#FFFFFF"
                >
                  {pageData?.ritualCategory?.title}
                </Text>
              </Box>
              {pageData?.availableOnline && (
                <Box px="6px" py="2px" bg="#DF6F3B" mr="10px">
                  <Text
                    fontFamily="FedraSansStd-book, sans-serif"
                    fontStyle="normal"
                    fontWeight="500"
                    fontSize={{ base: '9px', md: 'body2' }}
                    lineHeight={{ base: '12.46px', md: '22.14px' }}
                    textAlign="center"
                    letterSpacing="0.06em"
                    textTransform="uppercase"
                    color="#FFFFFF"
                  >
                    {pageData?.ritualStaticContent?.json?.availableOnline}
                  </Text>
                </Box>
              )}
            </Flex>
            {pageData?.locations?.length > 0 && (
              <Box mt={{ base: '15px', md: '12.42px' }}>
                <Text
                  color="#EBDEDE"
                  fontFamily="FedraSansStd-book, sans-serif"
                  fontStyle="normal"
                  fontWeight="400"
                  fontSize={{ base: '12px', md: 'body2' }}
                  lineHeight={{ base: '16.61px', md: '24.91px' }}
                  textTransform="uppercase"
                  fontFeatureSettings="'case' on"
                >
                  <TiLocationOutline
                    style={{
                      color: '#DF6F3B',
                      display: 'inline',
                      fontSize: '20px',
                      marginTop: '-2px',
                    }}
                  />{' '}
                  {pageData?.locations?.map((loc, index) => {
                    return (
                      index < 3 && (
                        <Box as="span" key={nanoid()}>
                          {loc.title || loc.name}
                          {index < pageData?.locations?.length - 1 ? ',' : ''}
                          &nbsp;
                        </Box>
                      )
                    );
                  })}
                  {pageData?.locations?.length > 3 && (
                    <Box as="span">
                      + {pageData?.locations?.length - 3} LOCATIONS
                    </Box>
                  )}
                </Text>
              </Box>
            )}
          </Box>
        </Box>
      </Box>
      <Flex
        pos="absolute"
        top="0"
        right={0}
        display={{ base: 'flex', md: 'none' }}
        left="0"
        padding="15px"
        width="100%"
        h="auto"
        alignItems="center"
        justifyContent="space-between"
        color="#F5D5A9"
      >
        <Box fontSize="18px" cursor="pointer" pos="relative" zIndex={10}>
          <BackIcon background="none" />
        </Box>
        <Box fontSize="18px" cursor="pointer" pos="relative" zIndex={10}>
          <ShareIcon background={'none'} url={url} />
        </Box>
      </Flex>
    </Box>
  );
};

// export { ShareIcon, BackArrow };
export default TopBannerEventRitual;
